require('normalize.css');
require('../vue/main');
